import { useTranslation } from 'react-i18next';
import { InlineAnchor, Typography } from '@figure/frontlib-gui';
import ReviewAppBase from '../components/ReviewAppBase';

const NotYetEligibleContainer = () => {
  const [t] = useTranslation();

  return (
    <ReviewAppBase>
      <Typography.Body>
        We'd love to serve you, however, you are not eligible for a new loan at this time. We
        require at least 90 days since your last issued loan OR having made your 3rd regularly
        scheduled monthly payment before you are eligible for a new loan. If you have further
        questions, please contact us at{' '}
        <InlineAnchor href={`tel:+${t('phone.unformatted')}`}>{t('phone.formatted')}</InlineAnchor>{' '}
        Monday - Sunday between 6am - 6pm PT. We hope to be able to serve you!
      </Typography.Body>
    </ReviewAppBase>
  );
};

export default NotYetEligibleContainer;
